import React, {
  useMemo,
  useState,
  useLayoutEffect,
  useEffect,
  createContext,
  useRef,
} from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import useApplicationData from "../../utils/hooks/useApplicationData"
import useFooterData from "../../utils/hooks/useFooterData"
import useLocale from "../../utils/hooks/useLocale"
import useNavigationData from "../../utils/hooks/useNavigationData"
import SiteNavigationHandler from "../SiteNavigationHandler/SiteNavigationHandler"
import { useQueryParams, StringParam } from "use-query-params"
import "./Layout.scss"
// import favicon from "../../images/favicon.svg"
import { navigate } from "gatsby-link"
import { useStore } from "../../context/auth/auth"
import { loadConfig } from "../../utils/config/config"
import { LayoutScriptLoader } from "./LayoutScriptLoader"
import { formatSiteConfigurationValues } from "../../utils/organism-formatting/formatSiteConfigurationValues"
import { useFlyout } from "../../utils/hooks/useFlyout"
import useAuthTID from "../../utils/hooks/useAuthTID"
import { FooterHandler, NavBarHandler, LoadingSpinner, Alert } from "terra-one"
import NavSearch from "../NavSearch/NavSearch"
import getConfigTID from "../../utils/functions/getConfigTID"
import useFlyoutCart from "../../utils/hooks/FlyoutCart/useFlyoutCart"
import popUpDialogVariantsOnLayout from "../../utils/variants/popUpDialogVariantsOnLayout"
import { Dialog } from "terra-one"

import FormatAndRenderSiteWideAlert from "../../utils/organism-formatting/SitewideAlert/FormatAndRenderSitewideAlert"
import { Footer, GlobalFooter, SectorFooter } from "trimble-terra"

const config =
  process.env.GATSBY_CONFIG_OVERRIDE &&
  JSON.parse(process.env.GATSBY_CONFIG_OVERRIDE)

const Layout = ({
  children,
  innerPageNavData,
  siteConfig,
  rawNavigationData,
  rawFlyoutData,
  rawFooterData,
  locale,
  location,
  commonSearches,
  rawAppData,
  loadModusStyle,
  hideNav,
  isPublicPage,
  region,
  languageSettings,
  saveLanguageSettings,
  products,
  munchkins,
  homepageSlug,
  siteIdentifier,
  seoStructuredData,
  regions,
  showJumpNav,
  jumpNavItems,
  jumpNavType,
  rawFlyoutCartData,
  currentSpaceId,
  onPageNavData,
  metaLocatorLanguage,
  ecommerceSettings,
  TIDredirect,
  siteNavigationData,
}) => {
  const [redirectPage, setRedirectPage] = useState(false)

  const [globalSearch, setGlobalSearch] = useState(false)
  const { applicationData } = useApplicationData(rawAppData)
  const [state, dispatch] = useStore()
  const [userData, setUserData] = useState(null)
  const [auth, setAuth] = useState(false)
  const [path, setPath] = useState(null)
  const [navBarReady, setNavBarReady] = useState(false)
  const [isMigratingAccount, setMigratingAccount] = useState(false)
  const [isServerError, setServerError] = useState(false)
  const navRef = useRef(null)
  const [alertHolderPosition, setAlertHolderPosition] = useState(105)
  const [isSubscriptionError, setSubscriptionError] = useState(false)
  const [isDX, setDX] = useState(false)
  const [loading, setLoading] = useState(false)
  const [owner, setOwner] = useState(false)
  const [admin, setAdmin] = useState(false)
  const [ecom, setEcom] = useState(false)

  const [projectSightProductRemoved, setProjectSightProductRemoved] =
    useState(false)
  const [cartUpdatedByAPI, setCartUpdatedByAPI] = useState(false)
  const [multiErrorMessage, setMultiErrorMessage] = useState(false)

  const showHorizontalJumpNav =
    showJumpNav && jumpNavType === "Horizontal" ? true : false

  useEffect(() => {
    const authPersistenceAcrossDomains = () => {
      const urlParams = new URLSearchParams(window?.location?.search)
      const checkForErrorInUrlParam = urlParams?.get("error")
      const prevLocation = localStorage?.getItem("redirectAfterAuth")
      if (
        checkForErrorInUrlParam &&
        checkForErrorInUrlParam === "login_required" &&
        prevLocation !== `/${locale}` &&
        prevLocation !== null &&
        // localStorage stringifies its value so we check for null as a string
        prevLocation !== "null"
      ) {
        localStorage.setItem("signIn", false)
        localStorage.removeItem("auth")
        navigate(prevLocation)
      }
    }

    const redirectAfterLogout = () => {
      if (typeof window !== "undefined") {
        if (window.location.pathname.includes("logout")) {
          if (
            localStorage.getItem("state") &&
            localStorage.getItem("state") !== "null"
          ) {
            window.open(
              `${window.location.origin}${localStorage.getItem("state")}`,
              "_self"
            )
          }
        }
      }
    }
    if (typeof window !== "undefined") {
      redirectAfterLogout()
      authPersistenceAcrossDomains()
    }
  }, [])

  // Login Data
  const loginPage = () => {
    //navigate(`/${locale}/${loadConfig().internal.auth}`)
  }
  const logout = () => {
    try {
      dispatch({
        type: "SIGN_OUT",
      })
    } catch (error) {
      console.log("logout error", error)
    }
  }
  const logoutUser = () => {
    const logoutBaseUrl =
      process.env.GATSBY_ENV === "staging"
        ? "https://stage.id.trimblecloud.com/oauth"
        : "https://id.trimble.com/oauth"

    const redirect_uri =
      typeof window !== "undefined"
        ? `${window.location.origin}/logout`
        : `http://localhost:8001/logout`
    if (typeof window !== "undefined") {
      window.open(
        `${logoutBaseUrl}/logout?id_token_hint=${
          JSON.parse(localStorage?.getItem("user-trial-data"))?.idTokenForLogout
        }&post_logout_redirect_uri=${redirect_uri}&state=${localStorage?.getItem(
          "state"
        )}`,
        "_self"
      )
      sessionStorage.removeItem("accountSelected")
      localStorage.removeItem("user_info")
      localStorage.removeItem("item_")
      localStorage.removeItem("timeStamp")
      localStorage.removeItem("user-trial-data")
      localStorage.removeItem("id_link")
      localStorage.removeItem("currency")
      localStorage.removeItem("country")
    }
    setAuth(false)
  }

  if (typeof window !== "undefined") {
    const user = localStorage?.getItem("user_info")
    if (user && !auth) {
      setAuth(true)
      setUserData(JSON.parse(user))
    }
  }

  const { navigationData } = useNavigationData(
    rawNavigationData,
    applicationData,
    locale,
    languageSettings,
    region,
    products,
    auth,
    siteIdentifier,
    regions
  )
  const newSiteNavigationData = useNavigationData(
    siteNavigationData,
    applicationData,
    locale,
    languageSettings,
    region,
    products,
    auth,
    siteIdentifier,
    regions
  )
  const {
    queryString,
    redirect_uri,
    code_verifier,
    client_id,
    url,
    client_secret,
    signUpQuery,
  } = getConfigTID(siteIdentifier)

  useAuthTID(
    setAuth,
    setUserData,
    userData,
    path,
    redirect_uri,
    code_verifier,
    client_id,
    client_secret,
    queryString,
    url,
    setDX,
    setLoading,
    setOwner,
    setAdmin,
    setEcom
  )

  if (typeof window !== "undefined" && !path) {
    setPath(window?.location?.pathname)
  }

  const isAuthenticated = state?.isAuthenticated
  const userProfile = state?.navData?.userProfile
  const newNavigationEnabled = !!rawAppData?.newNavigationFormat
  // Disables nav menus when user is not authenticated
  const disableMenus = config?.enableLogin && !isAuthenticated ? true : false

  // check here prevents build failing in case no navigation is selected
  rawNavigationData && (rawNavigationData.loginRedirect = loginPage)
  rawNavigationData && (rawNavigationData.logout = logout)
  rawNavigationData && (rawNavigationData.isAuthenticated = isAuthenticated)
  rawNavigationData && (rawNavigationData.userProfile = userProfile)
  rawNavigationData && (rawNavigationData.disableMenus = disableMenus)
  rawNavigationData && (rawNavigationData.isPublicPage = isPublicPage)

  const sectorFlyoutData = useFlyout(
    rawFlyoutData,
    newSiteNavigationData?.navigationData ? newSiteNavigationData?.navigationData : navigationData,
    locale,
    isAuthenticated,
    auth,
    userData,
    logoutUser,
    path,
    queryString,
    homepageSlug,
    currentSpaceId,
    products,
    siteIdentifier,
    isDX,
    owner,
    signUpQuery,
    admin,
    ecom,
    ecommerceSettings
  )

  const formatFlyout = {
    ...sectorFlyoutData,
    accountSwitcher: sectorFlyoutData?.accountSwitcher,
  }

  const navigationDataWithFlyout = newNavigationEnabled
    ? {
        ...newSiteNavigationData,
        sectorFlyoutData,
      }
    : {
        ...navigationData,
        sectorFlyoutData,
      }

  const { footerData } = useFooterData(
    rawFooterData,
    locale,
    homepageSlug,
    products,
    siteIdentifier
  )
  // Currently detects browser language and sets font-stack based on locale
  useLocale(locale, navigationDataWithFlyout, footerData, locale)

  const saveLanguage = newLanguage => {
    saveLanguageSettings(newLanguage)
  }

  const displaySiteWideAlert =
    applicationData?.siteAlertNotice?.length > 0 ? true : false

  // check nav data is supplied but isn't blank
  let innerPageNavHasData =
    innerPageNavData &&
    (innerPageNavData?.breadcrumbs?.length > 0 ||
      innerPageNavData?.siblingPages?.length > 0 ||
      onPageNavData?.navItems?.length > 0)

  /* eslint-disable-next-line no-unused-vars */
  const [query, _setQuery] = useQueryParams({
    search: StringParam,
  })

  const { search: initialParams } = query
  const [navElemHeight, setNavElemHeight] = useState(
    applicationData?.newNavigationFormat === true ? 106 : 93
  )
  const [searchDeployed, setSearchDeployed] = useState(!!initialParams)

  useEffect(() => {
    // open search if query param is present
    if (query?.search) {
      setSearchDeployed(true)
    }
  }, [query?.search])

  useEffect(() => {
    const htmlElem = document?.documentElement?.classList
    // remove search query param if search is closed
    if(searchDeployed === true){
      htmlElem?.add("ter-app--scroll-locked")
    }
    if (!searchDeployed) {
      _setQuery({ search: undefined }, "replaceIn")
      htmlElem?.remove("ter-app--scroll-locked")
    }
    return () => htmlElem.remove("ter-app--scroll-locked")
  }, [searchDeployed])

  let divisionName, franchise, subdivisionName, siteConfigValues, structuredData

  if (rawAppData) {
    siteConfigValues = formatSiteConfigurationValues(
      rawAppData?.siteConfigurationValues
    )
    divisionName = siteConfigValues?.divisionName
    franchise = siteConfigValues?.franchise
    subdivisionName = siteConfigValues?.subdivisionName

    structuredData = seoStructuredData?.data
      ? seoStructuredData?.data
      : {
          "@context": "https://schema.org",
          "@type": "Corporation",
          name: siteConfigValues?.name || "",
          location: siteConfigValues?.location || "",
          url: siteConfigValues?.url || "",
          telephone: siteConfigValues?.telephone || "",
        }
  }

  useEffect(() => {
    setNavElemHeight(
      navRef?.current?.clientHeight
    )
  }, [navRef?.current?.clientHeight])

  const AlertHolder = () => {
    return (
      <div className="luna-layout__alert-wrapper">
        <FormatAndRenderSiteWideAlert data={applicationData?.siteAlertNotice} />
      </div>
    )
  }
  const {
    cartSettings,
    handleCartChangeQuantity,
    handleCartRemoveItem,
    isCartFlyoutOpen,
    handleIsCartFlyoutOpen,
    currencies,
    defaultCurrency,
    currency,
    setCurrency,
    isCurrencyLocked,
    handleCloseSubscriptionDialog,
    isProjectSight,
    setIsProjectSight,
  } = useFlyoutCart({
    disableCartFlyout:
      !process.env.GATSBY_ECOMM_ENABLED ||
      process.env.GATSBY_ECOMM_ENABLED != "true"
        ? true
        : newSiteNavigationData?.navigationData?.disableCartFlyout,
    isAuthenticated: auth,
    rawFlyoutCartData,
    queryString,
    path,
    products,
    isMigratingAccount,
    setMigratingAccount,
    isServerError,
    setServerError,
    setSubscriptionError,
    client_id,
    client_secret,
    redirect_uri,
    code_verifier,
    setProjectSightProductRemoved,
    setCartUpdatedByAPI,
    setMultiErrorMessage,
  })

  useEffect(() => {
    // Disable scrolling when dialog is open
    if (
      typeof window !== "undefined" &&
      window?.document &&
      isSubscriptionError
    ) {
      document.body.style.overflow = "hidden"
      // Enable scrolling when dialog is closed
    } else if (
      typeof window !== "undefined" &&
      window?.document &&
      isCartFlyoutOpen
    ) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "unset"
    }
  }, [isSubscriptionError, isCartFlyoutOpen])

  const renderNewNav = () => {
    if (navigationDataWithFlyout?.navigationData) {
      return (
        <SiteNavigationHandler
          searchComponent={
            <NavSearch
              data={applicationData}
              initialParams={initialParams}
              searchDeployed={searchDeployed}
              commonSearches={commonSearches}
              locale={locale}
              globalSearch={globalSearch}
              navigationData={navigationDataWithFlyout?.navigationData}
              searchPromoCardsData={applicationData?.searchPromoCards}
              languageSettings={languageSettings}
              saveLanguageSettings={saveLanguageSettings}
            />
          }
          data={navigationDataWithFlyout?.navigationData}
          innerPageNavData={innerPageNavData}
          applicationData={applicationData}
          saveLanguage={saveLanguage}
          Link={Link}
          searchDeployed={!!initialParams}
          setSearchDeployed={setSearchDeployed}
          setGlobalSearch={setGlobalSearch}
          globalSearch={globalSearch}
          navigate={navigate}
          showJumpNav={showHorizontalJumpNav}
          jumpNavItems={jumpNavItems}
          navRef={navRef}
          cartData={state?.cart}
          cartSettings={cartSettings}
          onCartRemoveItem={handleCartRemoveItem}
          onCartChangeQuantity={handleCartChangeQuantity}
          isCartFlyoutOpen={isCartFlyoutOpen}
          onCartFlyoutOpen={handleIsCartFlyoutOpen}
          currencies={currencies}
          defaultCurrency={defaultCurrency}
          activeCurrency={currency}
          setCurrency={setCurrency}
          isCurrencyLocked={isCurrencyLocked}
          onPageNavData={onPageNavData}
          alertHolderComponent={displaySiteWideAlert && <AlertHolder />}
          flyout={navigationDataWithFlyout?.sectorFlyoutData}
          refreshTokenKeys={{
            client_id,
            client_secret,
            redirect_uri,
            code_verifier,
            path,
            url,
          }}
        />
      )
    }
  }

  const renderOldNav = () => {
    if (navigationDataWithFlyout) {
      return (
        <NavBarHandler
          data={navigationDataWithFlyout}
          innerPageNavData={innerPageNavData}
          history={null}
          applicationData={applicationData}
          saveLanguage={saveLanguage}
          Link={Link}
          searchDeployed={!!initialParams}
          setSearchDeployed={setSearchDeployed}
          setGlobalSearch={setGlobalSearch}
          globalSearch={globalSearch}
          navigate={navigate}
          isPublicPage={isPublicPage}
          searchComponent={
            <NavSearch
              data={applicationData}
              initialParams={initialParams}
              searchDeployed={searchDeployed}
              commonSearches={commonSearches}
              locale={locale}
              globalSearch={globalSearch}
              navigationData={navigationData}
              searchPromoCardsData={applicationData?.searchPromoCards}
              languageSettings={languageSettings}
              saveLanguageSettings={saveLanguageSettings}
            />
          }
          showJumpNav={showHorizontalJumpNav}
          jumpNavItems={jumpNavItems}
          navRef={navRef}
          cartData={state?.cart}
          cartSettings={cartSettings}
          onCartRemoveItem={handleCartRemoveItem}
          onCartChangeQuantity={handleCartChangeQuantity}
          isCartFlyoutOpen={isCartFlyoutOpen}
          onCartFlyoutOpen={handleIsCartFlyoutOpen}
          currencies={currencies}
          defaultCurrency={defaultCurrency}
          activeCurrency={currency}
          setCurrency={setCurrency}
          isCurrencyLocked={isCurrencyLocked}
          onPageNavData={onPageNavData}
          megaNavVariant={rawNavigationData?.megaNavVariant}
          alertHolderComponent={displaySiteWideAlert && <AlertHolder />}
        />
      )
    }
  }

  const renderMainNavigation = () => {
    if (newNavigationEnabled) {
      // NEW NAVIGATION
      return renderNewNav()
    } else {
      return renderOldNav()
    }
  }
  const legacyFooterData =
    footerData?.footerVariant === "Legacy"
      ? { ...footerData, globalFooterEnabled: false }
      : null

  return (
    <LayoutContext.Provider value={{ homepageSlug }}>
      <main
        className={`luna-layout ${
          !innerPageNavHasData ? "luna-layout--no-subnav" : ""
        } ${hideNav ? "luna-layout--no-nav" : ""}
        ${
          !innerPageNavHasData && navigationDataWithFlyout?.displayIcons
            ? "luna-layout--no-subnav--with-icons"
            : ""
        } ${
          !hideNav && navigationDataWithFlyout?.displayIcons
            ? "luna-layout--with-icons"
            : ""
        } ${
          config?.enableLogin && isPublicPage && !isAuthenticated
            ? "luna-layout--no-menu-nav"
            : ""
        }
        ${newNavigationEnabled ? "luna-layout--new-nav" : ""}`}
        style={
          navRef && {
            paddingTop: `${newNavigationEnabled && navElemHeight}px`,
          }
        }
      >
        <Helmet htmlAttributes={{ lang: languageSettings?.language?.code }}>
          <link
            rel="icon"
            type="image/png"
            href="/assets/favicon/favicon-96x96.png"
            sizes="96x96"
          />
          <link
            rel="icon"
            type="image/svg+xml"
            href="/assets/favicon/favicon.svg"
          />
          <link
            rel="icon"
            sizes="48x48"
            href="/assets/favicon/favicon-48x48.png"
          />
          <link rel="shortcut icon" href="/assets/favicon/favicon.ico" />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/assets/favicon/apple-touch-icon.png"
          />
          <link rel="manifest" href="/assets/favicon/site.webmanifest" />
          <link
            rel="icon"
            type="image/png"
            sizes="192x192"
            href="/assets/favicon/android-chrome-192x192.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="512x512"
            href="/assets/favicon/android-chrome-512x512.png"
          />
          <link
            rel="mask-icon"
            href="/assets/favicon/safari-pinned-tab.svg"
            color="#5bbad5"
          />
          <meta name="msapplication-TileColor" content="#da532c" />
          <meta name="theme-color" content="#ffffff" />
          {loadModusStyle && (
            <link
              href="/assets/stylesheets/reset-global.css"
              rel="stylesheet"
            />
          )}
          {loadModusStyle && (
            <link
              href="/assets/stylesheets/modus-variables-1.0.0.css"
              rel="stylesheet"
            />
          )}
          {process.env.GATSBY_ENV !== "production" && (
            <meta name="robots" content="noindex" />
          )}

          {franchise && <meta name="franchise" content={`${franchise}`} />}
          {divisionName && <meta name="division" content={`${divisionName}`} />}
          {subdivisionName && (
            <meta name="subdivision" content={`${subdivisionName}`} />
          )}
          <link rel="preconnect" href="https://images.ctfassets.net" />
          <link
            rel="preconnect"
            href="https://dev.visualwebsiteoptimizer.com"
          />
        </Helmet>
        {renderMainNavigation()}
        {TIDredirect && (
          <section
            style={{
              height: "1261px",
            }}
          >
            <div
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <LoadingSpinner />
            </div>
          </section>
        )}
        {!TIDredirect && children}
        {displaySiteWideAlert && (
          <div className="luna-layout__alert-wrapper">
            <FormatAndRenderSiteWideAlert
              data={applicationData?.siteAlertNotice}
            />
          </div>
        )}
        {footerData && footerData?.footerVariant === "Legacy" ? (
          <>
            <FooterHandler data={legacyFooterData} Link={Link} />
            <GlobalFooter
              logo={footerData?.logo}
              globalFooterText={footerData?.globalFooterText}
              legalStuff={footerData?.legalStuff}
              Link={Link}
            />
          </>
        ) : (
          <Footer {...footerData} Link={Link} />
        )}
        <LayoutScriptLoader
          siteConfig={rawAppData}
          siteConfigValues={siteConfigValues}
          munchkins={munchkins}
          structuredData={structuredData}
          metaLocatorLanguage={metaLocatorLanguage}
        />
      </main>
      {popUpDialogVariantsOnLayout(
        ecommerceSettings,
        isMigratingAccount,
        isServerError,
        setServerError,
        isSubscriptionError,
        projectSightProductRemoved,
        cartUpdatedByAPI,
        multiErrorMessage,
        handleCloseSubscriptionDialog
      )}
    </LayoutContext.Provider>
  )
}

export default Layout

export const LayoutContext = createContext({
  homepageSlug: "",
})